import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "~/ui-kit/components/Button/Button";
import { Input } from "~/ui-kit/components/Input/Input";

export type LoginFormProps = {
  orderId: string;
  customerEmail: string;
  setOrderId: (orderId: string) => void;
  setCustomerEmail: (orderEmail: string) => void;
  isDisableCTA?: boolean;
  onSubmit: () => void;
  isLoading?: boolean;
  isError?: boolean;
  errorMessage?: string;
};

export const LoginForm: FC<LoginFormProps> = ({
  orderId,
  customerEmail,
  setOrderId,
  setCustomerEmail,
  isDisableCTA,
  onSubmit,
  isLoading,
  isError,
  errorMessage,
}) => {
  const { t } = useTranslation();
  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit();
      }}
    >
      <div className="mb-3">
        <Input
          type="text"
          value={orderId}
          name="orderId"
          placeholder={t("backend:login_placeholder_order_number")}
          onChange={setOrderId}
          isError={isError}
        />
      </div>
      <div className="mb-3">
        <Input
          type="text"
          value={customerEmail}
          name="customerEmail"
          placeholder={t("backend:login_placeholder_email")}
          onChange={setCustomerEmail}
          isError={isError}
          errorMessage={errorMessage ? t(`backend:${errorMessage}`) : ""}
        />
      </div>
      <Button isLoading={isLoading} type="submit" disabled={isDisableCTA}>
        {t("backend:start")}
      </Button>
    </form>
  );
};
